import classNames from 'classnames';
import { ReactElement } from 'react';

import { Field } from '../Field/Field';
import { FormRadioButton } from '../RadioButton/FormRadioButton';
import styles from './RadioButtonGroup.styles.m.css';
import { RadioButtonGroupProps } from './RadioButtonGroup.types';

export const RadioButtonGroup = (props: RadioButtonGroupProps): ReactElement => {
  const { className, name, options } = props;

  return (
    <fieldset className={classNames(styles.container, className)}>
      {options.map((option) => {
        return (
          <Field
            key={option.value}
            type="radio"
            name={name}
            value={option.value}
            label={option.label}
            component={FormRadioButton}
          />
        );
      })}
    </fieldset>
  );
};
